import { SpinningLoader, styles } from '@frontend/design-system';

export const ScheduleRequestDetailsSpinnerLoader = () => (
  <div css={[styles.flexCenter, { height: 400 }]}>
    <SpinningLoader />
  </div>
);
